/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-11 13:58:09
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/_store/index.js
 */

import { GetZkzMemberInfo, GetUserInfo } from '../_api'
import { requestApi } from '@/frameworks/http/services'
const state = {
  isRefreshTable: false,
  ZKMemberList: [],
  ZKDepMemberList: [],
  ZZjgByZkjbAndUser: [],
  JHJCBDList: [],
  ZzjgSX: ''
}

const mutations = {
  SET_ISREFRESH_TABLE: (state, payload) => {
    state.isRefreshTable = payload
  },
  SET_DATA: (state, payload) => {
    state[payload.key] = payload.data
  }
}

const actions = {
  /**
   * 获取质控组成员
   * @param {Object} {UserId:'',Query:'',IsHlbcy:1,Zkzdm:'',Zkjb:1001}
   * @returns
   */
  GetZkzMemberInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetZkzMemberInfo', params)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  /**
   * 获取人员信息接口
   * @param {Object} {Query:'',OrgId:'',UserIds:'',ZzUserId:'',Zkjb:1001,PageIndex:1,PageSize:50}
   * @returns
   */
  GetUserInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetUserInfo', params)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  GetZzjgSX({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetZzjgSX', params)
        .then((res) => {
          resolve(res)
          commit('SET_DATA', {
            key: 'ZzjgSX',
            data: res.data
          })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  /**
   * 获取组织机构-列表
   * @param {Object} {Query:'',OrgId:'',UserIds:'',ZzUserId:'',Zkjb:1001,PageIndex:1,PageSize:50}
   * @returns
   */
  GetZZjgByZkjbAndUser({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetZZjgByZkjbAndUser', params)
        .then((res) => {
          resolve(res)
          commit('SET_DATA', {
            key: 'ZZjgByZkjbAndUser',
            data: res.data
          })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  /**
   * 获取所有组织机构--树结构
   * @param {Object}
   * @returns
   */
  GetAllZzjgTree({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetAllZzjgTree', params)
        .then((res) => {
          resolve(res)
          commit('SET_DATA', {
            key: 'ZZjgByZkjbAndUser',
            data: res.data
          })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  //查询检查表单列表
  GetJHJCBDList({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetJHJCBDList', params)
        .then((res) => {
          resolve(res)
          commit('SET_DATA', {
            key: 'JHJCBDList',
            data: res.data
          })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  // 根据查询条件获取表单数据
  GetJcbdByLX({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetJcbdByLX', params)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  // 获取表单项目标准
  GetBdDetailByBddm({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('GetBdDetailByBddm', params)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  // 保存组合表单
  SaveZHB({ commit }, params) {
    return new Promise((resolve, reject) => {
      requestApi('SaveZHB', params)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
